import React from "react";
import { motion } from "framer-motion";
import { XCircleIcon } from "lucide-react";
const PROBLEMS = ["Información contradictoria en foros, grupos y videos que nunca coinciden entre sí, y no sabés a quién creerle.", "Consulados que piden turnos imposibles de conseguir y respuestas que tardan meses en llegar.", "No saber por dónde empezar: qué partida pedir primero, a qué comune escribir ni cómo armar el árbol.", "Presupuestos altísimos de gestores que prometen turnos o plazos “garantizados” que después no cumplen.", "Miedo a gastar plata en apostillas y traducciones para después descubrir que la línea estaba interrumpida."];
export function Problems() {
  return <section className="w-full bg-cream px-5 py-10" data-id="element-131" data-mp="2f53cegndr6ud">
      <div className="mx-auto max-w-md" data-id="element-132" data-mp="2f6eemc16g6jd">
        <h2 className="text-center font-serif text-2xl font-bold text-deep-green" data-id="element-133" data-mp="hek02y9sv1xj">
          Seguro intentaste hacerlo muchas veces, y te encontraste con:
        </h2>

        <ul className="mt-6 space-y-3" data-id="element-134" data-mp="db45e7hajbnh">
          {PROBLEMS.map((p, i) => <motion.li key={i} initial={{
          opacity: 0,
          x: -12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="flex items-start gap-3 rounded-2xl border border-sand bg-beige p-4" data-id="element-135" data-mp="34pa8iusw77m3" data-mpi={i}>
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-700/80" aria-hidden="true" data-id="element-136" data-mp="3ngul4ncmr5dv" />
              <span className="text-sm leading-relaxed text-ink/85" data-id="element-137" data-mp="3sfxo8291v1j7">{p}</span>
            </motion.li>)}
        </ul>

        <p className="mt-8 text-center font-serif text-xl font-bold text-italian-green" data-id="element-138" data-mp="3en82lyxfnymm">
          Para eso hicimos esta herramienta 👇
        </p>
      </div>
    </section>;
}